import { z } from "zod";
import { PAKISTAN_PROVINCES } from "../constants/provinces.js";

export const upsertAddressSchema = z.object({
  id: z.string().optional(),
  label: z.string().trim().max(40).optional(),
  fullName: z.string().trim().min(2),
  phone: z.string().trim().min(7),
  line1: z.string().trim().min(3),
  line2: z.string().trim().optional(),
  city: z.string().trim().min(2),
  province: z.enum(PAKISTAN_PROVINCES),
  postalCode: z.string().trim().min(3),
  country: z.string().trim().min(2).default("Pakistan"),
  isDefault: z.boolean().default(false)
});
export type UpsertAddressInput = z.infer<typeof upsertAddressSchema>;
